// Extract the image slug for each possession in each possession group
const extractImages = data => [...new Set((data || { possessions: [] }).possessions
  .map(({ possessions }) => [...possessions])
  .reduce((acc, x) => [...acc, ...x], [])
  .map(({ image }) => image))];

export default extractImages;